export const GET_PLAN_WISE_ACTIVATION_REPORT_LIST = 'GET_PLAN_WISE_ACTIVATION_REPORT_LIST';
export const GET_PLAN_WISE_ACTIVATION_REPORT_LIST_SUCCESSFUL = 'GET_PLAN_WISE_ACTIVATION_REPORT_LIST_SUCCESSFUL';
export const GET_PLAN_WISE_ACTIVATION_REPORT_LIST_FAIL = 'GET_PLAN_WISE_ACTIVATION_REPORT_LIST_FAIL';
